/**
 * Feature flags for production rollout control
 *
 * Use these to gradually enable features for different user segments
 */

interface FeatureFlags {
  // Real-time collaboration features
  collaboration: {
    enabled: boolean;
    presenceIndicators: boolean;
    queryExecution: boolean;
    cursors: boolean;
  };

  // Environment-based overrides
  forceDisableInProduction: boolean;
}

const isDevelopment = import.meta.env.MODE === 'development';
const isProduction = import.meta.env.MODE === 'production';

export const features: FeatureFlags = {
  collaboration: {
    // Enable presence indicators (who's viewing)
    enabled: true,
    presenceIndicators: true,

    // Query execution notifications (Phase 2)
    queryExecution: true,

    // Cursor tracking (Phase 3)
    cursors: true,
  },

  // Safety: disable all features in production until ready
  forceDisableInProduction: false,
};

/**
 * Check if a feature is enabled
 */
export function isFeatureEnabled(feature: keyof FeatureFlags['collaboration']): boolean {
  if (features.forceDisableInProduction && isProduction) {
    return false;
  }

  return features.collaboration.enabled && features.collaboration[feature];
}

/**
 * Beta user check (expand this with actual user IDs from your database)
 */
export function isBetaUser(userId: string): boolean {
  const betaUserIds = [
    // Add beta user IDs here
  ];

  return isDevelopment || betaUserIds.includes(userId);
}
